// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"r_-z"};